import React, { useEffect, useState } from 'react'

import { Box } from 'widgets/Box'
import { TextButton } from 'widgets/Button'
import { Text } from 'widgets/Text'

export const StepDescription = ({ description }: { description: string }) => {
  const [shouldShowFullDescription, setShouldShowFullDescription] = useState(false)

  useEffect(() => {
    setShouldShowFullDescription(false)
  }, [description])

  const toggleShouldShowFullBio = () => {
    setShouldShowFullDescription((value) => !value)
  }
  return (
    <Box padding='smd'>
      <Text
        fontSize='sm'
        fontWeight='semiBold'
        color='textInverted'
        ellipsizeMode={!shouldShowFullDescription ? 'tail' : undefined}
        numberOfLines={!shouldShowFullDescription ? 2 : undefined}
        withLinks
      >
        {description}
      </Text>
      {description && (description.length > 200 || (description.match(/\n/g) || []).length > 2) ? (
        <Box align='flex-end'>
          <TextButton
            bold
            type='white'
            size='sm'
            underline={false}
            onPress={toggleShouldShowFullBio}
            title={!shouldShowFullDescription ? 'More...' : 'Less...'}
          />
        </Box>
      ) : null}
    </Box>
  )
}
